import { Locale } from "@hermes/locale";

import { PREFIX_A_B_TEST_KEY } from "./ab-testing.constant";

/**
 * @param locale locale
 * @returns the A/B test locale code in the format "_<COUNTRY>-<LANG>"
 */
export function getABTestLocaleCode(locale: Locale): `${string}-${string}` {
    return `${locale.code.replace("_", "-")}` as `${string}-${string}`;
}

/**
 * Determines whether a query parameter name matches
 * the naming convention of an A/B test
 * @param name Query parameter name
 * @returns `true` if the name corresponds to an A/B test, otherwise `false`
 */
export function isABTestQueryParameter(name: string): boolean {
    return name.startsWith(PREFIX_A_B_TEST_KEY);
}

/**
 * Determines whether a cookie name matches
 * the naming convention of an A/B test for the specified locale
 * @param cookieName Cookie name
 * @param abTestLocaleCode Locale code for A/B Test
 * @returns `true` if the name corresponds to an A/B test for teh current locale, otherwise `false`
 */
export function isCurrentLocaleABTestCookie(
    cookieName: string,
    abTestLocaleCode: string,
): boolean {
    return cookieName.startsWith(`${PREFIX_A_B_TEST_KEY}${abTestLocaleCode}`);
}

/**
 * Checks whether a pathname matches configured routes for A/B testing.
 * @param pathName PathName of the API request
 * @param routes List of routes configured for A/B testing (retrieve from KV config through `api_ab_routes` query parameter set by CF worker)
 * @returns `true` if the pathname matches at least one route, otherwise `false`.
 */
export function isPathMatchingRoutes(
    pathName: string,
    routes: string[],
): boolean {
    return routes.some((route) => {
        const routePattern = route
            // Escape RegExp specific characters
            .replace(/[$()+.[\\\]^{|}]/g, String.raw`\$&`)
            // Convert wildcard character
            .replace(/\*/g, ".*");
        return new RegExp(`^${routePattern}$`).test(pathName);
    });
}
